module.exports = __webpack_public_path__ + "img/hr-red-asterisk-16.21fa9b25.png";